module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/CouponClose.99383236.svg";